import fetch from 'isomorphic-fetch';
// import {logger} from 'legacy-logging-client';
import _isString from 'lodash/isString';
import _merge from 'lodash/merge';

const TIMEOUT_MS = 15000;

/**
 * Default values for the request object
 * @type {Object}
 */
const DEFAULT_REQUEST = {
  protocol: 'http',
  domain: 'localhost',
  port: '',
  path: ['/'],
  query: {},
};

/**
 * Default values for the options object
 * @type {Object}
 */
const DEFAULT_OPTIONS = {
  logger: null,
  timeout: TIMEOUT_MS,
};

/**
 * Builds a useable request object based off the request config
 * Protocol: Add a colon and forward slashes
 * Port: Add a colon if it exists
 * Path: Join the path array.
 *    i.e. [v1, people, 000] -> /v1/people/000
 * @param   {Object|String} reqConf The request configuration object or full URL string
 * @returns {Object} an object containing the url string and the query
 */
export function buildRequest(reqConf) {
  const reqObj = {};

  if (_isString(reqConf)) {
    const splitReq = reqConf.split('?');

    reqObj.url = splitReq[0];
    reqObj.query = splitReq[1];
  } else {
    const req = _merge({}, DEFAULT_REQUEST, reqConf);

    reqObj.url = [
      `${req.protocol}://`,
      req.domain,
      req.port ? `:${req.port}` : '',
      req.path.length === 0 ? '/' : `/${req.path.join('/')}`,
    ].join('');
    reqObj.query = req.query;
  }

  return reqObj;
}

/**
 * Makes an http post request via superagent
 * @param  {Object|String} reqConf The request configuration object
 * @param  {Object}        body    The body of the post
 * @param  {Object}        options Options to choose from
 * @return {Promise} The superagent Object (NOTE: Call .then to fire the request)
 */
function post(reqConf, body, options = {}) {
  const _request = buildRequest(reqConf);

  const isClient = typeof window !== 'undefined';
  const opts = _merge({}, DEFAULT_OPTIONS, options);

  const extras = {
    credentials: 'same-origin',
    timeout: 30000,
    ...opts,
  };

  const httpPost = fetch(_request.url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    ...(isClient ? {} : extras),
  });

  return httpPost.then(resp => resp.json()).then(json => json);
}

/**
 * Makes an http get request via superagent
 * @param  {Object} reqConf The request configuration objec
 * @param  {Object} options Options to choose from
 * @return {Object} The superagent Object (NOTE: Call .then to fire the request)
 */
function get(reqConf, options) {
  const _request = buildRequest(reqConf);

  const isClient = typeof window !== 'undefined';
  const opts = _merge({}, DEFAULT_OPTIONS, options);

  const extras = {
    credentials: 'same-origin',
    timeout: 30000,
    ...opts,
  };

  const httpGet = fetch(
    `${_request.url}${
      Object.keys(_request.query).length
        ? `?${Object.keys(_request.query)
            .map(el => `${el}=${_request.query[el]}`)
            .join('&')}`
        : ''
    }`,
    {
      method: 'GET',
      qs: _request.query,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      ...(isClient ? {} : extras),
    }
  );

  return httpGet.then(resp => resp.json()).then(json => json);
}

export default {
  post,
  get,
};



// WEBPACK FOOTER //
// ./src/appModules/utilities/api.js